import { createContext, ElementType } from 'react';
import { UserSettings } from 'src/types/UserSettings';
import { defaultUserSettings } from 'src/bootstrap/constants';
import { MandatoryFilterConfig } from 'src/utils/composeFilter.ts';
import { GetComparator } from 'src/common/types/Comparator.ts';
import { ButtonProps } from 'src/common/Button/Button.tsx';

export type ConfigContextProps = {
    uri: string;
    imageProxyUri: string;
    userSettings: UserSettings;
    mandatoryFilterConfig: MandatoryFilterConfig;
    accessoryPageMandatoryFilterConfig: MandatoryFilterConfig;
    rootElement: HTMLElement;
    numberFormat: {
        thousandSeparator: string;
        decimalSeparator: string;
    };
    currency: string | null;
    getComparator: GetComparator;
    gaPush: (event: unknown) => void;
    priceAttributeId: string | null;
    priceAttributeName: string | null;
    selectionsDefaults: {
        addToCartButtonEnabled: boolean;
        closeButtonType: ButtonProps<ElementType>['kind'];
        closeButtonSize: ButtonProps<ElementType>['size'];
        actionButtonType: ButtonProps<ElementType>['kind'];
        actionButtonSize: ButtonProps<ElementType>['size'];
    };
}

export const ConfigContext = createContext<ConfigContextProps>(
    {
        gaPush: () => null,
        getComparator: () => () => 0,
        imageProxyUri: '',
        uri: '',
        userSettings: defaultUserSettings,
        mandatoryFilterConfig: {
            config: [],
            values: {},
        },
        accessoryPageMandatoryFilterConfig: {
            config: [],
            values: {},
        },
        rootElement: document.createElement('div'),
        numberFormat: {
            thousandSeparator: ',',
            decimalSeparator: '.',
        },
        currency: null,
        priceAttributeName: null,
        priceAttributeId: null,
        selectionsDefaults: {
            addToCartButtonEnabled: true,
            closeButtonType: 'ghost-secondary',
            closeButtonSize: 'sm',
            actionButtonType: 'ghost-secondary',
            actionButtonSize: 'sm',
        },
    },
);
